import { ProgressBar } from '../../../../ProgressBar';
import '../style.css';

export function FH1ProgressBar(props) {
  return <div className='fh1-progress'><ProgressBar {...props} /></div>;
}
